import { isAdminRole } from './rolePermissions';

/**
 * Maps alert payloads to granular RBAC module requirements.
 * @param {object | null | undefined} alertItem
 * @returns {{ module: string, action: string } | null}
 */
export function getAlertModuleRequirement(alertItem) {
  if (!alertItem || typeof alertItem !== 'object') return null;

  const rule = String(alertItem.ruleCode || '').toUpperCase();
  const meta = alertItem.meta && typeof alertItem.meta === 'object' ? alertItem.meta : {};

  if (rule.startsWith('AI_SPEND_')) {
    return { module: 'aiSpend', action: 'read' };
  }

  if (
    meta.ticketId ||
    rule.startsWith('TICKET_') ||
    rule.endsWith('_TICKET') ||
    rule.includes('TICKET_')
  ) {
    return { module: 'ticketing', action: 'read' };
  }

  if (
    rule.startsWith('APP_LIVENESS') ||
    meta.appId ||
    meta.monitoringSource === true
  ) {
    return { module: 'monitoring', action: 'read' };
  }

  if (rule.startsWith('EXTERNAL_LINK') || meta.linkId) {
    return { module: 'externalLinks', action: 'read' };
  }

  if (
    rule.startsWith('TASK_') ||
    meta.taskId ||
    meta.linkedTaskId
  ) {
    return { module: 'agile', action: 'read' };
  }

  if (rule.startsWith('WEBHOOK_')) {
    return { module: 'ticketing', action: 'read' };
  }

  return null;
}

/**
 * Whether a user may see an alert in inbox UI (Super Admin always may).
 * @param {object | null | undefined} alertItem
 * @param {{ role?: string } | null | undefined} userData
 * @param {(module: string, action: string) => boolean} checkPermission
 */
export function canViewAlertForUser(alertItem, userData, checkPermission) {
  if (!alertItem) return false;
  if (userData?.role === 'super_admin') return true;

  const requirement = getAlertModuleRequirement(alertItem);
  if (!requirement) return true;

  if (requirement.module === 'aiSpend') {
    return isAdminRole(userData?.role);
  }

  return checkPermission(requirement.module, requirement.action);
}

/**
 * @param {object[]} alerts
 * @param {{ role?: string } | null | undefined} userData
 * @param {(module: string, action: string) => boolean} checkPermission
 */
export function filterAlertsByModuleAccess(alerts, userData, checkPermission) {
  if (!Array.isArray(alerts)) return [];
  if (userData?.role === 'super_admin') return alerts;
  return alerts.filter((item) => canViewAlertForUser(item, userData, checkPermission));
}
